import { useWeb3Context } from "../contexts/Web3";

export default function useAccount() {
  return useWeb3Context();
}
